import { jsPDF } from "jspdf";
import { toast } from "react-toastify";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";

export const handleRepairDownload = (repair: any) => {
  if (!repair) {
    alert("No repair data available");
    return;
  }

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const topMargin = 20;
  const bottomMargin = 20;
  const sideMargin = 10;

  const primaryColor = [0, 122, 90];
  const headerBgColor = [0, 122, 90];

  let currentY = topMargin;

  const image = new Image();
  image.src = "/images/logo.png";

  image.onload = async function () {
    /* ================= LOGO ================= */
    const aspect = image.naturalWidth / image.naturalHeight;
    const logoHeight = 20;
    const logoWidth = logoHeight * aspect;
    doc.addImage(image, "PNG", sideMargin, topMargin, logoWidth, logoHeight);

    /* ================= COMPANY DETAILS ================= */
    const companyStartY = topMargin + logoHeight + 5;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(
      "Quick Engineering Solutions Pvt. Ltd.",
      sideMargin,
      companyStartY
    );

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    let txtY = companyStartY + 5;
    doc.text(
      "Naya Nagar, CDF Industrial Area, Anopshahar Road,",
      sideMargin,
      txtY
    );
    txtY += 5;
    doc.text("Cherat, Aligarh, Uttar Pradesh 202122", sideMargin, txtY);
    txtY += 5;
    doc.text("Email: qenggsolutions@gmail.com", sideMargin, txtY);
    txtY += 5;
    doc.text("Phone: +91 8077774614", sideMargin, txtY);

    const leftBottom = txtY;

    /* ================= TITLE ================= */
    let rightY = topMargin;
    const title =
      repair.requestType === "replacement"
        ? "Replacement Request"
        : "Repair Request";

    doc.setFont("helvetica", "bold");
    doc.setFontSize(24);
    doc.setTextColor(...primaryColor);
    doc.text(
      title,
      pageWidth - sideMargin - doc.getTextWidth(title),
      rightY
    );

    rightY += 8;
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `#${repair.orderNumber || "N/A"}`,
      pageWidth -
      sideMargin -
      doc.getTextWidth(`#${repair.orderNumber || "N/A"}`),
      rightY
    );

    // ===== WARRANTY FULL FORM BELOW ORDER NUMBER =====
    rightY += 6;
    const warranty = repair.warrantyType?.toUpperCase();

    const rightMarginOffset = 10; // ⬅ Extra margin from right

    if (warranty === "CUW") {
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);

      const text = "Complaint Under Warranty";
      doc.text(
        text,
        pageWidth -
        sideMargin -
        rightMarginOffset -
        doc.getTextWidth(text),
        rightY
      );
    }

    if (warranty === "COW") {
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);

      const text = "Complaint Out of Warranty";
      doc.text(
        text,
        pageWidth -
        sideMargin -
        rightMarginOffset -
        doc.getTextWidth(text),
        rightY
      );
    }



    currentY = Math.max(leftBottom, rightY) + 15;

    /* ================= CLIENT DETAILS ================= */
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(...primaryColor);
    doc.text(
      repair.companyName?.toUpperCase() || "NO COMPANY NAME",
      sideMargin,
      currentY
    );

    currentY += 8;
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);

    doc.setFont("helvetica", "normal");
    const label1 = "Received By : ";
    doc.text(label1, sideMargin, currentY);

    doc.setFont("helvetica", "bold");
    doc.text(
      repair.receivedBy || "N/A",
      sideMargin + doc.getTextWidth(label1) + 2,
      currentY
    );

    doc.setFont("helvetica", "normal"); // ✅ RESET HERE
    currentY += 6;

    doc.text(
      `Department Person : ${repair.departmentPerson || "N/A"}`,
      sideMargin,
      currentY
    );
    currentY += 6;

    doc.text(`Reseller : ${repair.reseller || "N/A"}`, sideMargin, currentY);

    currentY += 12;

    /* ================= ITEMS TABLE ================= */
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Items", sideMargin, currentY);
    currentY += 4;

    const tableWidth = pageWidth - 2 * sideMargin;
    const colWidths = [
      12, // S.No.
      55, // Instrument Name
      18, // Qty
      40, // Server ID
      tableWidth - (12 + 55 + 18 + 40), // Remark (Auto)
    ];


    const headers = ["S.No.", "Instrument Name", "Qty", "Server ID", "Remark"];

    doc.setFillColor(...headerBgColor);
    doc.rect(sideMargin, currentY, tableWidth, 10, "F");
    doc.setTextColor(255, 255, 255);

    let x = sideMargin;
    headers.forEach((h, i) => {
      doc.text(h, x + colWidths[i] / 2, currentY + 5, {
        align: "center",
        baseline: "middle",
      });
      x += colWidths[i];
    });

    doc.setTextColor(0, 0, 0);
    currentY += 10;

    const items = Array.isArray(repair.items) && repair.items.length > 0
      ? repair.items
      : [
        {
          name: repair.instrumentName,
          serverId: repair.serverId,
          quantity: repair.quantity,
          remark: repair.remark,
        },
      ];


    items.forEach((item: any, i: number) => {
      const nameLines = doc.splitTextToSize(
        String(item.name || "N/A"),
        colWidths[1] - 4
      );
      const remarkLines = doc.splitTextToSize(
        String(item.remark || ""),
        colWidths[4] - 4
      );

      const rowHeight = Math.max(
        nameLines.length * 5,
        remarkLines.length * 5,
        10
      );

      if (i % 2 === 0) {
        // Even row → White
        doc.setFillColor(255, 255, 255);
      } else {
        // Odd row → Light Gray
        doc.setFillColor(245, 245, 245);
      }
      doc.rect(sideMargin, currentY, tableWidth, rowHeight, "F");

      // S.No.
      doc.text(
        String(i + 1),
        sideMargin + colWidths[0] / 2,
        currentY + rowHeight / 2,
        { align: "center" }
      );

      // Item
      doc.text(
        nameLines,
        sideMargin + colWidths[0] + colWidths[1] / 2,
        currentY + rowHeight / 2,
        { align: "center" }
      );

      // ✅ Qty (CORRECT POSITION)
      const qty = String(item.quantity || 1);

      doc.text(
        qty,
        sideMargin +
        colWidths[0] +
        colWidths[1] +
        colWidths[2] / 2,
        currentY + rowHeight / 2,
        { align: "center" }
      );

      // ✅ Server ID (CORRECT POSITION)
      const serverIDFormatted =
        item.serverId || repair.serverId || "N/A";

      doc.text(
        String(serverIDFormatted),
        sideMargin +
        colWidths[0] +
        colWidths[1] +
        colWidths[2] +
        colWidths[3] / 2,
        currentY + rowHeight / 2,
        { align: "center" }
      );

      // Remark
      const remarkX =
        sideMargin +
        colWidths[0] +
        colWidths[1] +
        colWidths[2] +
        colWidths[3] +
        2; // left padding

      const remarkY = currentY + 5; // top padding

      doc.text(remarkLines, remarkX, remarkY, {
        maxWidth: colWidths[4] - 4,
        align: "left",
      });

      currentY += rowHeight;
    });

    /* ================= ISSUE BOX (ONLY IF EXISTS) ================= */
    if (repair.issueDescription) {
      currentY += 8;

      const issueWidth = pageWidth - 2 * sideMargin;
      const issueLines = doc.splitTextToSize(
        repair.issueDescription,
        issueWidth - 6
      );
      const boxHeight = issueLines.length * 5 + 12;


      doc.setFont("helvetica", "bold");
      doc.text("Issue Description", sideMargin + 3, currentY + 6);

      doc.setFont("helvetica", "normal");
      doc.text(issueLines, sideMargin + 3, currentY + 12);

      currentY += boxHeight;
    }

    /* ================= EXTRA DETAILS ================= */
    currentY += 15;

    doc.setFont("helvetica", "bold");
    doc.text("Handover Person", sideMargin, currentY);
    doc.setFont("helvetica", "normal");
    currentY += 6;
    doc.text(repair.handoverPerson || "N/A", sideMargin, currentY);

    currentY += 8;
    doc.setFont("helvetica", "bold");
    doc.text("Dates", sideMargin, currentY);
    doc.setFont("helvetica", "normal");
    currentY += 6;
    doc.text(
      `Received: ${repair.receivingDate
        ? new Date(repair.receivingDate).toLocaleDateString("en-GB")
        : "N/A"
      }`,
      sideMargin,
      currentY
    );
    currentY += 5;
    doc.text(
      `Expected Delivery: ${repair.expectedDeliveryDate
        ? new Date(repair.expectedDeliveryDate).toLocaleDateString("en-GB")
        : "N/A"
      }`,
      sideMargin,
      currentY
    );

    /* ================= SMART FEEDBACK BOX ================= */

    // Footer ke liye space reserve
    const footerSpace = 15;

    // Page ke end tak kitni space bachi
    const remainingHeight =
      pageHeight - currentY - bottomMargin - footerSpace;

    // Minimum usable height
    const minFeedbackHeight = 25;

    // Agar space bahut kam ho → new page
    if (remainingHeight < minFeedbackHeight) {
      doc.addPage();
      currentY = topMargin;
    }

    // Recalculate after page add
    const usableHeight =
      pageHeight - currentY - bottomMargin - footerSpace;

    // Actual box height (dynamic)
    const feedbackBoxHeight = usableHeight - 10;

    currentY += 10;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("Feedback*", sideMargin, currentY);

    currentY += 4;

    // Draw box
    doc.setDrawColor(0, 0, 0);
    doc.rect(
      sideMargin,
      currentY,
      pageWidth - 2 * sideMargin,
      feedbackBoxHeight
    );

    // Move Y below box
    currentY += feedbackBoxHeight;


    /* ================= FOOTER ================= */
    const now = new Date();
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    doc.text(
      `Generated on: ${now.toLocaleDateString("en-GB")} ${now.toLocaleTimeString(
        "en-GB"
      )} IST`,
      sideMargin,
      pageHeight - bottomMargin
    );

    /* ================= UNIVERSAL DOWNLOAD (WEB + APK) ================= */

    const platform = Capacitor.getPlatform();

    // ✅ SAFE FILE NAME
    const safeRepair = String(repair.orderNumber || "REQUEST").replace(
      /[^a-zA-Z0-9]/g,
      "_"
    );
    const fileName = `Repair_${safeRepair}.pdf`;

    // 🌐 WEB
    if (platform === "web") {
      const blob = doc.output("blob");
      const reader = new FileReader();

      reader.onloadend = () => {
        const a = document.createElement("a");
        a.href = reader.result as string;
        a.download = fileName;
        a.target = "_blank";
        a.click();
      };

      reader.readAsDataURL(blob);
      toast.success("PDF downloaded successfully!");
      return;
    }

    // 📱 ANDROID APK
    const base64 = doc.output("datauristring").split(",")[1];

    const result = await Filesystem.writeFile({
      path: `QESPL/${fileName}`,
      data: base64,
      directory: Directory.Documents,
      recursive: true,
    });

    await Share.share({
      title: fileName,
      text: "Repair Request",
      url: result.uri,
      dialogTitle: "Share Repair PDF",
    });

    toast.success("PDF saved & ready to share!");
  };

  // ================= IMAGE ERROR =================
  image.onerror = () => {
    toast.error("Failed to load logo image");
  };
};